const currentUrl = window.location.href;
const mailButton = document.getElementById('mail-share-button');
const copyButton = document.getElementById('copy-button');
var mailtoLink = 'mailto:?subject=Članok%20od%20Arbitra&body=' + encodeURIComponent(currentUrl);

mailButton.addEventListener("click", () => {window.location.href = mailtoLink});
copyButton.addEventListener("click", () => {
    navigator.clipboard.writeText(currentUrl)
    .then(() => { 
        const tooltip = document.getElementById('sucess-tooltip');
        tooltip.style.display = "block";
        setTimeout(() => { tooltip.style.removeProperty('display'); }, "1500" )
     })
});